import { Component, Input, OnInit, Output, OnDestroy, EventEmitter } from '@angular/core';

import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { userActions } from '@src/store/reducers/userReducer';

import * as _ from 'lodash';

@Component({
    selector: 'user-group',
    template: require('./user-group.component.html'),
    styles: [require('./user-group.component.scss')]
})
export class UserGroupComponent implements OnInit, OnDestroy {
    @Input() public set group(value) {
        this._tempGroup = this.deepCopy(value);
        this._group = value;
        this.setGroupUsers();
    }

    public get group() {
        return this._group;
    }

    @Output() public onDelete = new EventEmitter();
    @Output() public onDuplicate = new EventEmitter();

    public usersInGroup: any[] = [];

    private _group: any;
    private _tempGroup: any;
    private unSubscribers: any[];
    private unSubscribe: any;
    private users: any;
    public isSyncEnabled: boolean = false;
    public AuthType:string

    constructor(
        private store: Store,
        private dialogManagerService: DialogManagerService,
        private translatePipe: TranslatePipe) {
    }

    public ngOnInit() {
        this.AuthType = JSON.parse(localStorage.getItem('AuthType'))
        this.unSubscribers = [
            this.store.subscribe(() => {
                const userState = this.store.getState().user;
                if (userState.users) {
                    this.users = userState.users;
                }
                if (userState.group) {
                    this.group = userState.group;
                }
            })
        ];
        this.store.dispatch({ type: userActions.GET_USERS });
        this.store.dispatch({ type: userActions.IS_SYNC_ENABLED })
            .then((isSync) => {
                this.isSyncEnabled = isSync;
            });
    }

    public ngOnDestroy() {
        this.unSubscribers.forEach(x => x());
    }

    public async assignUser() {
        const modalUsers = this.deepCopy(this.users);
        const availableUsers = _.differenceBy(modalUsers, this.usersInGroup, 'id');

        if (availableUsers.length > 0) {
            this.dialogManagerService.showAddFromListDialog(
                {
                    title: 'Select User',
                    contentClass: 'assign-users-popup',
                    placeholder: 'Search',
                    items: availableUsers
                },
                (data) => {
                    if (!this._group.users) {
                        this._group.users = [];
                    }
                    const usersSelected = _.filter(data.items, { selected: true });
                    usersSelected.forEach((user: any) => {
                        this._group.users = [...this._group.users, user];
                    });
                    this.setGroupUsers();
                });
        } else {
            const translations = await this.translatePipe.transform(['ERROR', 'ERROR_NO_USERS']);
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: translations['ERROR_NO_USERS']
            });
        }
    }

    private setGroupUsers() {
        this.usersInGroup = [];
        if (this._group && this._group.users) {
            this.usersInGroup = this._group.users;
        }
    }

    public removeGroupUser(removedItem: any) {
        this._group.users = this._group.users.filter((user: any) => {
            if (user.id !== removedItem.id) {
                return user;
            }
        });
        this.setGroupUsers();
    }

    public save() {
        if (!this._group.description) {
            this._group.description = '';
        }
        if (!this._group.users) {
            this._group.users = null;
        }
        if (this._group.isNew) {
            this._group.id = -1;
            this.unSubscribe = this.store.subscribe(() => {
                const groupState = this.store.getState().user.group;
                if (groupState) {
                    delete this.group.isNew;
                    this._group.id = groupState.id;
                    this.unSubscribe();
                }
            });
            this.store.dispatch({
                type: userActions.ADD_USER_GROUPS,
                payload: { groupData: this._group }
            });
        } else {
            this.store.dispatch({
                type: userActions.SAVE_GROUP,
                payload: { groupId: this._group.id, groupData: this._group }
            });
        }
    }

    public cancel() {
        this._group = this._tempGroup;
        this.setGroupUsers();
        this._tempGroup = this.deepCopy(this._group);
    }

    private deepCopy(obj: any) {
        if (!obj) {
            return obj;
        }

        return _.cloneDeep(obj);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/usersManagement/users-groups/user-group/user-group.component.ts